"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notify = void 0;
const ChannelInstructionType_1 = require("../channelInstruction/ChannelInstructionType");
const MessageType_1 = require("../message/MessageType");
const IResult_1 = require("../shared/IResult");
class Notify {
    constructor(request, endpointEngagedHandler) {
        this.request = request;
        this.endpointEngagedHandler = endpointEngagedHandler;
        this.userInteractionRequired = this.isUserInteractionRequired();
        if (this.request.payload.channelInstruction.uiPages && this.request.payload.channelInstruction.uiPages.length > 0) {
            this.uiContent = this.request.payload.channelInstruction.uiPages[0];
        }
        else {
            this.uiContent = this.request.payload.channelInstruction.uiContentJSON;
        }
    }
    proceed() {
        if (this.userInteractionRequired) {
            const endpointEngagedRequest = {
                messageName: MessageType_1.MessageType.EndpointEngagedRequest,
                payload: {
                    channelInstruction: {
                        type: this.request.payload.channelInstruction.type,
                    },
                    messageID: this.request.payload.messageID,
                    interaction: {
                        entersektInteractionID: this.request.payload.interaction.entersektInteractionID,
                        type: this.request.payload.interaction.type,
                    },
                    result: {
                        action: IResult_1.Action.APPROVED,
                    },
                },
            };
            return this.endpointEngagedHandler.endpointEngaged(endpointEngagedRequest);
        }
        else {
            return Promise.resolve();
        }
    }
    isUserInteractionRequired() {
        if (this.request.payload.channelInstruction.type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_RESULT_PAUSE ||
            this.request.payload.channelInstruction.type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_CHECK_PAUSE) {
            return true;
        }
        else
            return false;
    }
}
exports.Notify = Notify;
//# sourceMappingURL=Notify.js.map